module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BoldItalic.6c59a874.ttf";